import React from 'react';
export function Footer() {
  return <footer className="border-t border-dark-border bg-black px-4 py-8 text-center text-sm text-gold-dark" data-id="element-90">
      © {new Date().getFullYear()} Mega Pack Historia 360 — Todos los derechos
      reservados.
    </footer>;
}